export interface ErrorMessage {
  property: string;
  fullMessage: string;
  message: string;
}

export class ApiError {
  error: ErrorMessage[];
  status: number;
  path: string;
  timestamp: string;

  constructor(error: ErrorMessage[], status: number, path: string) {
    this.error = error;
    this.status = status;
    this.path = path;
    this.timestamp = new Date().toISOString();
  }

  static compatible(json: any): json is ApiError {
    return (
      json.error &&
      Array.isArray(json.error) &&
      json.status &&
      json.path &&
      json.timestamp
    );
  }
}
